export { default } from './Link';
export type { Props, Props as CardLinkProps } from './Link';
